(function () {
  if (window.__arcticSmileRewardsPanelReady) return;
  window.__arcticSmileRewardsPanelReady = true;

  function openSmilePanel(deepLink) {
    var smileUi = window.SmileUI;
    if (!smileUi) return false;

    function open() {
      if (typeof smileUi.openPanel !== 'function') return false;
      if (deepLink) {
        smileUi.openPanel({ deep_link: deepLink });
      } else {
        smileUi.openPanel();
      }
      return true;
    }

    if (open()) return true;

    if (typeof smileUi.ready === 'function') {
      smileUi.ready(function () {
        smileUi = window.SmileUI;
        if (smileUi && typeof smileUi.openPanel === 'function') {
          if (deepLink) {
            smileUi.openPanel({ deep_link: deepLink });
          } else {
            smileUi.openPanel();
          }
        }
      });
      return true;
    }

    return false;
  }

  function openSmilePanelWhenAvailable(deepLink, attempt, onOpen) {
    if (openSmilePanel(deepLink)) {
      if (typeof onOpen === 'function') onOpen();
      return true;
    }

    if (attempt >= 20) return false;

    window.setTimeout(function () {
      openSmilePanelWhenAvailable(deepLink, attempt + 1, onOpen);
    }, 250);

    return true;
  }

  function getSmileDeepLinkFromUrl() {
    var search = window.location.search;
    var match;

    if (!search) return '';

    match = search.match(/[?&]smile_deep_link=([^&]+)/);
    if (!match) return '';

    try {
      return decodeURIComponent(match[1].replace(/\+/g, ' '));
    } catch (error) {
      return '';
    }
  }

  function removeSmileDeepLinkFromUrl() {
    var url;

    if (!window.history || typeof window.history.replaceState !== 'function') return;
    if (typeof URL !== 'function') return;

    url = new URL(window.location.href);
    if (!url.searchParams.has('smile_deep_link')) return;

    url.searchParams.delete('smile_deep_link');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var trigger = target.closest('[data-smile-panel-trigger], [data-cart-loyalty-redeem]');
    if (!trigger) return;

    var deepLink = trigger.getAttribute('data-smile-deep-link');
    if (!openSmilePanel(deepLink)) return;

    event.preventDefault();
  });

  function openInitialSmileDeepLink() {
    var deepLink = getSmileDeepLinkFromUrl();
    if (!deepLink) return;

    openSmilePanelWhenAvailable(deepLink, 0, removeSmileDeepLinkFromUrl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openInitialSmileDeepLink);
  } else {
    openInitialSmileDeepLink();
  }
})();
